import BaseServiceCrud from './BaseServiceCrud';
import {saveAs} from 'file-saver';

export default class CardOrderTemplateService extends BaseServiceCrud {
    // Initializing important variables
    constructor() {
        super();
        this.path = 'card-order-template';
    }

    getFleetGoodGroup() {
        // Get a token from api server using the fetch api
        return this.fetch(`${this.domain}/${this.path}/fleet-good-group`, {
            method: 'GET',
        }).then((res) => {
            return Promise.resolve(res);
        });
    }

    getCriteria(criteria) {
        return this.objToQueryString({});
    }

    getTemplateFile(request, fileLabel, handleError) {
        const url = new URL(`${this.domain}/${this.path}/template`);
        const headers = {
            'Content-Type': 'application/json',
            'Cache-Control': 'no-cache, no-store, must-revalidate',
            Pragma: 'no-cache',
        };
        if (this.auth.loggedIn()) {
            headers['Authorization'] = this.auth.getToken();
        }
        this.fetchPost(url, request, headers)
            .then((response) => {
                return response.blob();
            })
            .then((blob) => {
                saveAs(blob, fileLabel);
            })
            .catch((err) => {
                if (handleError) {
                    handleError('Nie można pobrać pliku!');
                }
            });
    }
}
